import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { FingerprintService } from '@/app/core/services';

@Injectable()
export class FingerprintInterceptor implements HttpInterceptor {
    constructor(private fingerprintService: FingerprintService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.fingerprintService.getFingerprint().pipe(
            take(1),
            switchMap((fingerprint) => {
                if (fingerprint) {
                    request = request.clone({
                        setHeaders: {
                            'x-device-fingerprint': fingerprint,
                        },
                    });
                }
                return next.handle(request);
            }),
        );
    }
}
